///include /assets/js/app/p/user.js

const notificationCentre = Vue.component('notification-centre', {
    template: "#notification-centre",
    props: {
        user: {
            type: User,
            required: true,
        },
    },

    data() {
        return {
            notifications: [],
            filters: [
                {
                    title: "Domain Transfers",
                    helpText: "Domain transfer completion status",
                    name: 'domain-transfer',
                    value: true,
                    resellerOnly: false
                },
                {
                    title: "Malware Reports",
                    helpText: "Malware is found on a site during the automated daily malware scan",
                    name: 'malware',
                    value: true,
                    resellerOnly: false
                },
                {
                    title: "Website Migrations",
                    helpText: "Website migration completion status",
                    name: 'website-migration',
                    value: true,
                    resellerOnly: false
                },
                {
                    title: "Cloud Server Provision Status",
                    helpText: "Confirms a new Cloud Server is being provision",
                    name: 'cloud-server',
                    value: true,
                    resellerOnly: false
                },
                {
                    helpText: "Platform transfer completion status",
                    title: "Platform Transfer",
                    name: 'platform-transfer',
                    value: true,
                    resellerOnly: false
                },
                {
                    title: "Support Ticket Updates",
                    helpText: "Updates on your 20i support tickets",
                    name: 'support-ticket',
                    value: true,
                    resellerOnly: false
                },
                {
                    title: "StackCP Ticket System Updates",
                    helpText: "Updates from your customers through ticket system",
                    name: 'helpdesk',
                    value: true,
                    resellerOnly: true
                },
                {
                    title: "StackCP User Updates",
                    helpText: "New customer created and customer paid notifications",
                    name: 'stack-user',
                    value: true,
                    resellerOnly: true
                },
                {
                    title: "StackStatus Updates",
                    helpText: "Active incidents and scheduled maintenance notifications",
                    name: 'stackstatus',
                    value: true,
                    resellerOnly: true
                },
                {
                    title: "Referal Payout",
                    helpText: "Rereral Payout made to balance",
                    name: 'marketing',
                    value: true,
                    resellerOnly: false
                },
                {
                    title: "Timeline Backups Restore",
                    helpText: "Timeline Backups restore status",
                    name: 'timeline-backups',
                    value: true,
                    resellerOnly: true
                },
            ],
            showAll: true,
            fetch_interval: null,
            is_active: true,
        }
    },

    computed: {
        filteredNotifications() {
            if (this.notifications.length > 0) {
                const notifications = this.notifications;

                return this.notifications.filter(n => {
                    let condition = true;

                    if (!this.showAll) {
                        condition = !n.UserRead
                    }

                    // if condition is already false return, otherwise check if event type is disabled
                    if (condition) {
                        const filter = this.filters.find(f => f.name === n.Event.split(":")[0]);

                        if (filter) {
                            condition = filter.value;
                        } else {
                            condition = false;
                        }
                    }

                    return condition;
                });
            } else {
                return [];
            }
        },

        unreadNotificationsCount() {
            if (this.filteredNotifications.length > 0) {
                return this.filteredNotifications.reduce((acc, cv) => {
                    if (!cv.UserRead) return acc + 1

                    return acc
                }, 0)
            } else {
                return 0
            }
        },

        filteredFilters() {
            return this.filters.filter(n => !n.resellerOnly ? true : this.isReseller);
        },

        isReseller() {
            return this.user.hasReseller
        },
    },

    methods: {
        toggleFilter(name) {
            let filter = this.filters.find(f => f.name === name);
            filter.value = !!filter.value;

            const updatedFilters = this.filters.map(f => { return { name: f.name, value: f.value } })

            $.ajax({
                url: `/a/userNotifications/filters`,
                method: "post",
                data: {
                    filters: updatedFilters,
                }
            });
        },

        setFilters() {
            $.ajax(`/a/userNotifications/filters`).then(r => {
                if (r.Filters && r.Filters.length > 0) {
                    for (let filter of r.Filters) {
                        let defaultFilter = this.filters.find(f => f.name === filter.name);

                        defaultFilter.value = (filter.value === 'true');
                    }
                }
            });
        },

        toggleRead(id) {
            let notification = this.notifications.find(e => e.Id === id);

            notification.UserRead = !notification.UserRead;

            $.ajax({
                url: `/a/userNotifications/toggleRead`,
                method: "post",
                data: {
                    notificationIds: [notification.Id],
                    read: notification.UserRead
                }
            });
        },

        markAllRead() {
            const ids = [];
            for (let notification of this.notifications) {
                notification.UserRead = true;
                ids.push(notification.Id);
            }

            $.ajax({
                url: `/a/userNotifications/toggleRead`,
                method: "post",
                data: {
                    notificationIds: ids,
                    read: true
                }
            });
        },

        async fetchNotifications() {
            const oldNotifications = this.filteredNotifications;
            await $.ajax(`/a/userNotifications`).then(r => this.notifications = r);

            if (Notification.permission !== 'denied' || Notification.permission !== 'default') {
                let lastShownId = localStorage.getItem('latestNotificationId');

                if (!lastShownId) {
                    const latestOldNotification = oldNotifications.shift();

                    if (!latestOldNotification) return;

                    lastShownId = localStorage.setItem('latestNotificationId', latestOldNotification.Id);
                }

                const latestNewNotification = this.filteredNotifications[0];

                if (!latestNewNotification) return;

                if (lastShownId < latestNewNotification.Id) {
                    new Notification(latestNewNotification.Title, { body: latestNewNotification.Body, icon: `/assets/images/icons/notifications-centre/${latestNewNotification.Svg}` });

                    localStorage.setItem('latestNotificationId', latestNewNotification.Id)
                }
            }
        },

        askNotificationPermission() {
            function handlePermission(permission) {
                if (!Reflect.has(Notification, 'permission')) {
                    Notification.permission = permission;
                }

                let notificationBtn = $('#notification-button');
                if (Notification.permission === 'denied' || Notification.permission === 'default') {
                    notificationBtn.show();
                } else {
                    notificationBtn.hide();
                }
            };

            if (!Reflect.has(window, 'Notification')) {
                console.log('This browser does not support notifications.');
            } else {
                Notification.requestPermission().then(handlePermission);
            }
        },
        handleVisibilityChange() {
            if (document.visibilityState === 'visible') {
                this.is_active = true;
                this.startFetching();
            } else {
                this.is_active = false;
                this.stopFetching();
            }
        },
        startFetching() {
            if (!this.fetch_interval) {
                this.fetch_interval = setInterval(() => {
                    if (this.is_active) {
                        this.fetchNotifications();
                    }
                }, 20000);
            }
        },
        stopFetching() {
            if (this.fetch_interval) {
                clearInterval(this.fetch_interval);
                this.fetch_interval = null;
            }
        },
    },

    async mounted() {
        this.setFilters();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.startFetching();

        let notificationBtn = $('#notification-button');
        if (Notification.permission === 'denied' || Notification.permission === 'default') {
            notificationBtn.show();
        } else {
            notificationBtn.hide();
        }

        $(".dropdown-menu").click(function (e) {
            e.stopImmediatePropagation();
        })

        $('.dropdown-menu').mouseleave(function (e) {
            $('.dropdown-menu').dropdown('hide')
        })
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.stopFetching();
    },
})